import React from 'react';
import {AuthenticatedTemplate, UnauthenticatedTemplate} from "@azure/msal-react";
import {JobListing} from "./helpers/JobListing";
import {Link} from "react-router-dom";
import {useSelector} from "react-redux";

export default function InstallationHub() {

    const jobListSkim = useSelector(state => state.jobListSkim)

    return (
        <div>
            <AuthenticatedTemplate>
                <div className="title-container">
                    <h1>Admin Team Installation Hub</h1>
                </div>
                <div className="page-container">
                    <div className="page-section">

                        <h2>Unassigned Installation Jobs</h2>

                        {jobListSkim.unassignedList.slice(0, -1).map(job => {
                            return (<JobListing job={job} gradient={false} key={job.ID}/>)
                        })}
                        {jobListSkim.unassignedList.slice(-1).map(job => {
                            return (<JobListing job={job} gradient={true} key={job.ID}/>)
                        })}

                        <Link to="/installation/unassigned">
                            <button className="btn btn-secondary">View all unassigned installation jobs...</button>
                        </Link>

                    </div>
                    <div className="page-section">

                        <h2>Assigned Installation Jobs</h2>

                        {jobListSkim.assignedList.slice(0, -1).map(job => {
                            return (<JobListing job={job} gradient={false} key={job.ID}/>)
                        })}
                        {jobListSkim.assignedList.slice(-1).map(job => {
                            return (<JobListing job={job} gradient={true} key={job.ID}/>)
                        })}

                        <Link to="/installation/assigned">
                            <button className="btn btn-secondary">View all assigned installation jobs...</button>
                        </Link>

                    </div>
                    <div className="page-section">

                        <h2>Completed Installation Jobs</h2>

                        {jobListSkim.completedList.slice(0, -1).map(job => {
                            return (<JobListing job={job} gradient={false} key={job.ID}/>)
                        })}
                        {jobListSkim.completedList.slice(-1).map(job => {
                            return (<JobListing job={job} gradient={true} key={job.ID}/>)
                        })}

                        <Link to="/installation/completed">
                            <button className="btn btn-secondary">View all completed installation jobs...</button>
                        </Link>

                    </div>
                </div>
            </AuthenticatedTemplate>
            <UnauthenticatedTemplate>
                <p>You are trying to view the installation hub page while signed out. Please sign in to continue.</p>
            </UnauthenticatedTemplate>
        </div>
    );
}
